import { render, staticRenderFns } from "./ResidenceList.vue?vue&type=template&id=4b38714b&scoped=true&"
import script from "./ResidenceList.vue?vue&type=script&lang=js&"
export * from "./ResidenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38714b",
  null
  
)

export default component.exports